import { HAS_NOTIFICATIONS } from '@/fragments/notifications'
import { NORMAL_POLL_INTERVAL_MS, SSR } from '@/lib/constants'
import { useQuery } from '@apollo/client/react'
import React, { useContext, useEffect } from 'react'
import { clearNotifications } from '@/components/serviceworker'

export const HasNewNotesContext = React.createContext(false)

export function HasNewNotesProvider ({ me, children }) {
  const { data } = useQuery(HAS_NOTIFICATIONS,
    SSR
      ? {}
      : {
          pollInterval: NORMAL_POLL_INTERVAL_MS,
          nextFetchPolicy: 'cache-and-network'
        })

  useEffect(() => {
    if (data && !data.hasNewNotes) {
      clearNotifications()
    }
  }, [data?.hasNewNotes])

  return (
    <HasNewNotesContext.Provider value={!!data?.hasNewNotes}>
      {children}
    </HasNewNotesContext.Provider>
  )
}

export function useHasNewNotes () {
  return useContext(HasNewNotesContext)
}
